import React from 'react';
import { injectIntl } from 'react-intl';
import { Grid, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const IconStyle = {
  fontSize: '100px'
};

const TitleTypoStyle = {
  fontWeight: 'bold',
  margin: '30px 0 15px 0'
};

const SubTitleTypoStyle = {
  marginBottom: 10
};

const RegisterSuccess = props => {
  const { intl } = props;

  return (
    <Grid container spacing={2} sx={{ flexDirection: 'column', alignItems: 'center' }}>
      <Grid>
        <CheckCircleRoundedIcon color="primary" style={IconStyle} />
      </Grid>
      <Grid>
        <Typography variant="h3" style={TitleTypoStyle}>
          {intl.formatMessage({ id: 'Thank you' })}
        </Typography>
      </Grid>
      <Grid>
        <Typography variant="h5" style={SubTitleTypoStyle}>
          {intl.formatMessage({ id: 'pa-register-success' })}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default injectIntl(RegisterSuccess);
